export const CHANGE_NETWORK_STATUS = 'CHANGE_NETWORK_STATUS';

export function changeNetworkStatus(networkStatus) {
	return { type: CHANGE_NETWORK_STATUS, networkStatus };
}
